import React, { Fragment } from 'react';
import { withRouter } from '../../utils/withRouter';
import withStyles from '@mui/styles/withStyles';
import { compose, Query } from '../../reactApolloCompat';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import gql from 'graphql-tag';
import Typography from '@mui/material/Typography';
import { Mutation } from '../../reactApolloCompat';
import IconButton from '@mui/material/IconButton';
import TextField from '../form/TextField';
import Grid from '../layout/Grid';
import { NoteIcon, ReportsIcon } from '../IconIndex';
import { ADDRESSBOOK_CATEGORY_OPTIONS } from '../../utils/strings';

/*
 * Renders the notes for a contact, includes editing.
 *
 * @param contactId is used to query for the details
 * @param contactNotes is used to compare the original to the edit
 * @param onClose can update the caller with the mutation result
 */
class ContactAddNote extends React.Component {
    state = {
        open: false, notes: null, busy: false
    };

    render() {
        const { contactId, contactNotes, classes, contact } = this.props;
        const { open, notes } = this.state;
        const hasNote = (contactNotes !== null && contactNotes !== undefined) || notes !== null;
        return (
            <Fragment>
                <IconButton
                    onClick={this.handleClickOpen}
                    className={hasNote ? classes.buttonNote : classes.buttonNoNote}
                    title={hasNote ? 'Review Notes' : 'Add Notes'} size="large">
                    {hasNote ? <NoteIcon /> : <ReportsIcon />}
                </IconButton>
                {open && (<Dialog open={open} onClose={this.handleClose} disableBackdropClick>
                    {(contact && this.renderContent({
                        loading: false,
                        error: false,
                        data: { readCremationManagerAddressBooks: { edges: [{ node: contact }] } }
                    })) || (<Query query={contactQuery} variables={{ id: contactId }} fetchPolicy="network-only">
                        {results => this.renderContent(results)}
                    </Query>)}
                </Dialog>)}
            </Fragment>
        );
    }

    renderContent({ loading, error, data }) {
        if (error) {
            console.error(error);
            return <div>Error: Can't read data!</div>;
        }

        if (loading) {
            return <div>Loading notes...</div>;
        }

        const contactEdges = data.readCremationManagerAddressBooks && data.readCremationManagerAddressBooks.edges;

        //start to run Query, return loading message.
        if (!contactEdges) {
            return <div>Loading...</div>;
        }

        //loaded, but no edges, return not found message.
        if (contactEdges.length <= 0) {
            return <div>Contact Not Found!</div>;
        }

        const contactData = contactEdges[0].node;

        const { classes } = this.props;

        const cat = ADDRESSBOOK_CATEGORY_OPTIONS.find(e => {
            return e.value === contactData.AddressBookCategory;
        });

        const { busy, notes } = this.state;
        const variables = {
            input: {
                ID: contactData.ID, Notes: notes
            }
        };

        return (<Fragment>
            {/* <div style={{ width: 600, maxWidth: 'calc(100vw - 64px)', overflow: 'hidden' }}> */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    overflow: 'hidden',
                    pointerEvents: 'none'
                }}
            >
                <NoteIcon
                    style={{
                        opacity: 0.025,
                        width: 300,
                        height: 300,
                        position: 'absolute',
                        right: -24,
                        top: -24,
                        transform: 'rotate(20deg)',
                        zIndex: 0
                    }}
                />
            </div>
            <DialogTitle className={classes.title}>CONTACT NOTES</DialogTitle>
            <DialogContent style={{ width: 600, maxWidth: '100%' }}>
                <Typography variant="subtitle1">
                    {contactData.Name}
                    <span style={{ fontSize: '0.875rem', marginLeft: 12 }}>{contactData.Contact}</span>
                </Typography>
                <Typography variant="subtitle2">
                    {cat && cat.label}
                </Typography>
                <div style={{ paddingBottom: 24, marginTop: 12, borderTop: '1px dotted #999' }} />
                <Grid container spacing={3}>
                    <Grid pc={1}>
                        <TextField
                            name="notes"
                            label="Enter additional notes here..."
                            value={notes !== null ? notes : contactData.Notes}
                            multiline
                            disabled={busy}
                            rows={12}
                            onChange={e => {
                                const newState = { notes: notes };
                                newState.notes = e.target.value;
                                this.setState(newState);
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <Mutation mutation={contactMutation} variables={variables} onCompleted={this.handleClose}>
                {(mutate, { loading }) => {
                    const disabled = loading || notes === contactData.Notes || notes === null;
                    return (<DialogActions>
                        {(disabled && (<Button color="primary" onClick={this.handleClose}>
                            Close
                        </Button>)) || (
                            <Button className={classes.buttonCancel} onClick={this.handleClose} color="primary">
                                Cancel
                            </Button>)}
                        <Button
                            onClick={e => this.onSave(mutate, !disabled && variables, e)}
                            className={classes.buttonSave}
                            color="primary"
                            disabled={disabled}
                        >
                            {busy ? 'Saving...' : 'Save'}
                        </Button>
                    </DialogActions>);
                }}
            </Mutation>
            {/*</div>*/}
        </Fragment>);
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = data => {
        this.setState({ open: false, notes: null, busy: false });
        const { onClose } = this.props;
        if (data && data.updateCremationManagerAddressBook && onClose) onClose(data.updateCremationManagerAddressBook);
    };

    onSave = (mutate, variables, e) => {
        e.preventDefault();
        this.setState({ busy: true });
        if (variables) mutate({ variables });
    };
}

const contactMutation = gql`
    mutation($input: UpdateCremationManagerAddressBookInput!) {
        updateCremationManagerAddressBook(input: $input) {
            ID
            Notes
        }
    }
`;

const contactQuery = gql`
    query($id: String) {
        readCremationManagerAddressBooks(id: $id) {
            edges {
                node {
                    ID
                    Name
                    Contact
                    Notes
                    AddressBookCategory
                }
            }
        }
    }
`;

const styles = ({ palette }) => ({
    buttonCancel: { color: '#E64040' }, buttonSave: { color: '#26CC6F' }, buttonNote: {
        marginRight: '0.5em', color: palette.primary.main
    }, buttonNoNote: {
        marginRight: '0.5em', color: palette.primary.light + '66',
        '&:hover':{
            color: palette.primary.light
        }
    }
});

export default compose(withRouter, withStyles(styles))(ContactAddNote);
